'use client';

import { homeConfig } from '@/features/home/home.config';
import { useT } from 'next-i18next/client';
import type { FC } from 'react';

const FEATURE_ICONS = [
  <svg key="0" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3" />
    <path d="M12 9v-6M15 12h6M12 15v6M9 12H3" />
  </svg>,
  <svg key="1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
  </svg>,
  <svg key="2" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" />
  </svg>,
  <svg key="3" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v1m0 16v1M4.22 4.22l.7.7m12.16 12.16.7.7M3 12h1m16 0h1M4.22 19.78l.7-.7M18.36 5.64l.7-.7" />
    <circle cx="12" cy="12" r="4" />
  </svg>,
];

const featureKeys = [
  ['home:features.item_0_title', 'home:features.item_0_description'],
  ['home:features.item_1_title', 'home:features.item_1_description'],
  ['home:features.item_2_title', 'home:features.item_2_description'],
  ['home:features.item_3_title', 'home:features.item_3_description'],
] as const;

export const FeaturesBlock: FC = () => {
  const { t } = useT(homeConfig.i18nNamespaces);

  const features = featureKeys.map((keys, index) => ({
    index,
    title: t(keys[0]),
    description: t(keys[1]),
  }));

  return (
    <section className="bg-[#0A0A0A] py-24 md:py-[96px]">
      <div className="container grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-16 items-start">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E]">
            {t('home:features.label')}
          </p>
          <h2 className="mt-4 text-[clamp(36px,4vw,56px)] font-medium tracking-[-0.025em] leading-[1] text-white">
            {t('home:features.title')}
          </h2>
          <p className="mt-6 text-base text-white/60 max-w-xs leading-6">
            {t('home:features.description')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {features.map((feature) => (
            <div
              key={feature.index}
              className="border border-white/10 p-6 h-full"
            >
              <span className="text-[#F24E1E]">{FEATURE_ICONS[feature.index]}</span>
              <h3 className="mt-4 text-base font-medium text-white">{feature.title}</h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
